/**
 * DevTools console logs for JSON import/export flows.
 * Filter console by: Superadmin config JSON import/export
 */

const PREFIX = "[Superadmin config JSON import/export]";

export function summarizePayload(payload) {
    if (!payload || typeof payload !== "object") {
        return { topLevelKeys: 0, approxJsonChars: 0 };
    }
    try {
        const json = JSON.stringify(payload);
        return {
            topLevelKeys: Object.keys(payload).length,
            approxJsonChars: json.length,
        };
    } catch {
        return { topLevelKeys: Object.keys(payload).length, approxJsonChars: 0 };
    }
}

/** Successful export — file download prepared from current tab state */
export function logExport(flow, detail) {
    console.info(PREFIX, "EXPORT", flow, detail);
}

/** Import lifecycle: read → parse → pick(+optional prune) → setState (MongoDB only after Save) */
export function logImport(flow, phase, detail, err) {
    if (err) {
        console.error(PREFIX, "IMPORT", flow, phase, detail, err);
    } else {
        console.info(PREFIX, "IMPORT", flow, phase, detail);
    }
}

/** After Save API succeeds — confirms payload reached backend (see server logs for MongoDB write) */
export function logSaveClient(flow, ok, detail, err) {
    if (ok) {
        console.info(PREFIX, "SAVE_OK → API (MongoDB on server — see Node logs)", flow, detail);
    } else {
        console.error(PREFIX, "SAVE_FAILED", flow, detail, err);
    }
}
